/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { BaseAction } from '../../types/global.type';
import * as actions from 'src/types/config-action.type';

export type ConfigState = {
  accessToken?: string,
  platformToken?: string,
  licenseId?: string,
  serviceId?: string,
  identityId?: string,
  isExternal?: boolean,
  analyticsEnabled?: boolean,
};

const initialState = {
  accessToken: undefined,
  platformToken: undefined,
  licenseId: undefined,
  serviceId: undefined,
  identityId: undefined,
  isExternal: false,
  analyticsEnabled: false,
}

export const configReducer = (
  state: ConfigState = initialState,
  action: BaseAction
) => {
  switch (action.type) {
    case actions.SET_VALUE_SUCCESS:
      return {
          ...state,
          [action.payload.field]: action.payload.value
      };
    default:
      return state
  }
}
